"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AccordionItemTitle = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Accordion = require("./Accordion.styled");

var _hocs = require("../hocs");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var DownArrowIcon = function DownArrowIcon(props) {
  return _react.default.createElement("svg", props, _react.default.createElement("path", {
    d: "M7.41 7.84L12 12.42l4.59-4.58L18 9.25l-6 6-6-6z"
  }));
};

DownArrowIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
};

var AccordionItemTitle = function AccordionItemTitle(_ref) {
  var theRef = _ref.theRef,
      handleIndexChange = _ref.handleIndexChange,
      currentIndex = _ref.currentIndex,
      clickedItemIndex = _ref.clickedItemIndex,
      children = _ref.children;
  return _react.default.createElement(_Accordion.StyledAccordionTitleContainer, {
    ref: theRef,
    isSelected: clickedItemIndex === currentIndex,
    onClick: function onClick() {
      return handleIndexChange(clickedItemIndex);
    }
  }, children, _react.default.createElement(DownArrowIcon, null));
};

var accordionItemTitleWithRef = (0, _hocs.withForwardRef)(AccordionItemTitle);
exports.AccordionItemTitle = accordionItemTitleWithRef;
AccordionItemTitle.defaultProps = {
  clickedItemIndex: undefined,
  currentIndex: undefined,
  handleIndexChange: undefined
};
AccordionItemTitle.propTypes = {
  clickedItemIndex: _propTypes.default.number,
  currentIndex: _propTypes.default.number,
  handleIndexChange: _propTypes.default.func
};